import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddSection from "../../../containers/superadmin/sections/models/add-section";
import SearchBar from "../../../containers/superadmin/sections/searchbar";
import SuperadminSectionsTable from "../../../containers/superadmin/sections/table";
import {
  getAllSuperadminSectionsRequest,
  getCourseSectionRequest,
} from "../../../modules/superadmin-modules/sections/Actions";

const SuperadminSections = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [courseId, setCourseId] = useState(null);

  useEffect(() => {
    if (courseId) {
      dispatch(getCourseSectionRequest(courseId));
    } else dispatch(getAllSuperadminSectionsRequest());
  }, [courseId]);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setCourseId={setCourseId} />
      <SuperadminSectionsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
      />
      <AddSection
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SuperadminSections;
